import { NgModule } from '@angular/core';
import { DoubleClickDirective } from './double-click/double-click';
@NgModule({
	declarations: [DoubleClickDirective],
	imports: [],
	exports: [DoubleClickDirective]
})
export class DirectivesModule {}
